import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { ROUTES } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '@meddata/core/interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import { NoirPreset } from '@meddata/core/theme/noir.preset';

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(ROUTES),
		provideHttpClient(withInterceptors([authInterceptor])),
		provideAnimations(),
		providePrimeNG({
			theme: {
				preset: NoirPreset,
				options: {
					cssLayer: { name: 'primeng' },
					darkModeSelector: 'none'
				}
			}
		})
	]
};
